import React from 'react';
import Wrapper from './styles';
import { translate } from '../../../services/translate';

interface Props {
    type: string;
    extraInfo?: string;
}

export default function SportBadge({ type, extraInfo }: Props) {
    if (!type) {
        return null;
    }

    function formatType() {
        if (type === 'betbuilder') {
            return 'SGP';
        }
        return translate(type, 'sport.badge');
    }

    return (
        <Wrapper type={type} className="sport-badge">
            {`${formatType()} ${extraInfo ? `- ${extraInfo}` : ''}`}
        </Wrapper>
    );
}
